import React from "react";
import styled, { css } from "styled-components";
import NumberUtils from "util/NumberUtils";
const LegendList = styled.ul(
  ({ theme }) => css`
    display: grid;
    grid-template-columns: 1fr;
    gap: ${theme.spacings.xs};
    margin: 0;
    padding: 0;
    overflow-y: auto;
    list-style: none;
    max-height: 300px;
  `
);
const LegendItem = styled.li`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  gap: ${({ theme }) => theme.spacings.xs};
  align-items: center;
  min-width: 0;
`;
const LegendSwatch = styled.span`
  width: 10px;
  height: 10px;
  background: ${({ $color }) => $color};
`;
const LegendLabel = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const LegendValue = styled.span`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.fonts.size.small};
  white-space: nowrap;
`;
const LegendsWithPercent = ({ legends }) => /* @__PURE__ */ React.createElement(LegendList, null, legends.map(({ value, label, numberValue, percentageValue, color }) => /* @__PURE__ */ React.createElement(LegendItem, { key: value }, /* @__PURE__ */ React.createElement(LegendSwatch, { $color: color }), /* @__PURE__ */ React.createElement(LegendLabel, { title: label }, label), /* @__PURE__ */ React.createElement(LegendValue, null, NumberUtils.formatNumber(numberValue), " (", NumberUtils.formatPercentage(percentageValue), ")"))));
export default LegendsWithPercent;
